import axios from 'axios'
import VueAxios from 'vue-axios'
import {getAccessToken} from "@/storage/token";
import store from '@/store'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  //baseURL: "http://127.0.0.1:8000",
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 6000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
//   if (error.response) {
//     const data = error.response.data
//     console.log(data)
//   }
  return Promise.reject(error)
}

// 请求拦截处理器
request.interceptors.request.use(config => {
  const token = getAccessToken()
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Token'] = token
  }
  return config
}, errorHandler)

// 响应拦截处理器
request.interceptors.response.use((response) => {
  const result = response.data
  if ((response.config.url !== '/user/logout' && response.config.url !== '/auth/login')
      && (result.code === "token_expired" || result.code === "token_invalid")) {
    store.dispatch('Logout').then(() => {
      // message.error(result.msg, 2, () => {
      //   window.location.reload()
      // })
    })
  }
  return result
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as MyVueAxios,
  request as axios
}
